import classNames from 'classnames';

import { getEnvironmentDisplay } from '../../lib/environment';

type EnvironmentBadgeProps = {
  fixed?: boolean;
  className?: string;
};

const EnvironmentBadge: React.FC<EnvironmentBadgeProps> = ({
  fixed = false,
  className,
}) => {
  const display = getEnvironmentDisplay();

  if (!display) {
    return null;
  }

  return (
    <span
      className={classNames(
        'inline-flex h-6 items-center rounded-full px-2.5 text-small-label font-semibold uppercase tracking-wide',
        display.badgeClassName,
        fixed && 'fixed top-3 right-4 z-[60]',
        className,
      )}
    >
      {display.label}
    </span>
  );
};

export default EnvironmentBadge;
